import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import {
  contactEmail,
  evalImages,
  evaluatePrice,
  evaluateSlabPrice,
} from "../enums";

const useStyles = makeStyles((theme) => ({
  smallFont: {
    fontSize: "small",
  },
  title: {
    paddingTop: theme.spacing() * 2,
    marginBottom: theme.spacing(),
  },
  subtitle: {
    paddingTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
  section: {
    marginBottom: theme.spacing(),
  },
  sectionPlus: {
    marginBottom: theme.spacing() * 2,
  },
  cardImage: {
    maxWidth: 200,
  },
  cleanImage: {
    maxWidth: 300,
  },
  centerGrid: {
    textAlign: "center",
  },
  cardSection: {
    marginTop: theme.spacing() * 2,
    marginBottom: theme.spacing() * 2,
  },
  smallSection: {
    marginBottom: theme.spacing() / 2,
    fontSize: "small",
  },
  eval: {
    maxWidth: "100%",
  },
  evalContainer: {
    marginBottom: theme.spacing() / 2,
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="h5" className={classes.title}>
        Grade Prep & Evaluation
      </Typography>
      <Typography variant="h6" className={classes.subtitle}>
        Raw Card Evaluation
      </Typography>
      <Typography variant="body1" className={classes.section}>
        The most frequently requested service we provide is a pre-grading card
        prep and evaluation. Due to today's excessive cost of grading, this
        service frequently saves customers money by eliminating cards from your
        submission that won't grade well. Unlike bulk submitters who will take
        any card sent to them and submit them blindly, we offer a thorough
        evaluation process to set expectations prior to submitting your cards.
      </Typography>
      <Typography variant="body1" className={classes.section}>
        For ${evaluatePrice} per card, we perform a thorough wipe of your card
        and prep it for grading by providing a new sleeve and card saver. During
        this process we measure your cards centering, and under lighted
        magnification we inspect your cards surface, edges and corners. Based on
        our findings of all four grading sub-categories (centering, edges,
        surface, and corners) we provide you with our opinion of how we feel the
        card will do in grading and make a recommendation of what we'd do with
        each card if it were our own. After our inspection, our findings are
        sent to the client for them to review. They can then ultimately make a
        final decision to grade a card, where to grade a card, or to not grade a
        card at all. In the event that a card is to be kept raw and not graded,
        it's simply sent back at no additional charge.
      </Typography>
      <Typography variant="body1" className={classes.section}>
        Because we grade so frequently to all four major grading companies (BGS,
        PSA, SGC) we have an understanding of what specific card characteristics
        each company typically grades the hardest and subsequently which they
        grade the most lenient. Your evaluation will inform you if your card is
        likely to gem, what grade we feel it will get, and where would we send
        it if it was mine to the highest grade and/or best ROI. That may also
        include a recommendation of not grading it and keeping it raw.
      </Typography>
      <Typography variant="body1" className={classes.section}>
        To begin the process for a card evaluation, click the link{" "}
        <Link to="/order">here</Link>, enter your information, grading
        preference, card information and for each card elect for raw card
        evaluation. This will waive the cost of grading and only charge for the
        evaluation. Use the link to send your payment for the evaluation, print
        your QR code and carefully package your collectables. Be sure to include
        the QR code in your package and send it to our secure PO Box address.
        You will be contacted the day your cards arrive and shortly thereafter
        with the results of our evaluation process.
      </Typography>
      <Typography variant="h6" className={classes.subtitle}>
        Slabbed Card Evaluation
      </Typography>
      <Typography variant="body1" className={classes.section}>
        We also perform thorough evaluation of already graded (slabbed) cards
        with the purpose of cracking it out and re-submitting for a better
        grade. For a ${evaluateSlabPrice} fee we'll perform the same thorough
        evaluation we offer for raw cards but through the existing plastic slab.
        Afterwards we will provide our opinion on the pros and cons of either
        cracking out the card from the existing slab or possibly sending in the
        graded card as a crossover (meaning the grading company will grade the
        card through the slab and only remove it if it achieves the minimum
        grade we request).
      </Typography>
      <Typography variant="body1" className={classes.section}>
        Oftentimes a grading increase of even a half a point or more can offer
        large premiums when selling a card. We'll evaluate the card through the
        slab and give you our best judgement on if it would do better being
        re-graded or graded by another company. We do not crack any slabs
        without confirming all details with you the client. We will offer an
        opinion of what we'd do, which also can include our recommendation to
        leave it slabbed as is (risk isn't worth the reward, or card appears to
        be graded accurately or even graded lenient compared to what we see).
        But if we feel a card was graded harshly, or can do better at another
        grading company we will recommend a crack out of the card for client
        once their approval is given. Please note the ${evaluateSlabPrice} fee
        includes the evaluation but covers the crack out as well in the event
        the client gives the go-ahead.
      </Typography>
      <Typography variant="body1" className={classes.sectionPlus}>
        To begin the process for a slabbed card evaluation, click the link{" "}
        <Link to="/order">here</Link>, enter your information, grading
        preference, card information and for each card elect for slabbed card
        evaluation. This will waive the cost of grading and only charge for the
        evaluation. Use the link to send your payment for the evaluation, print
        your QR code and carefully package your collectables. Be sure to include
        the QR code in your package and send it to our secure PO Box address.
        You will be contacted the day your cards arrive and shortly thereafter
        with the results of our evaluation process.
      </Typography>
      <Grid container spacing={2} className={classes.evalContainer}>
        {evalImages.map((evalImage) => (
          <Grid item xs={12} md={6} key={evalImage}>
            <img className={classes.eval} src={evalImage} />
          </Grid>
        ))}
      </Grid>
      {"z".repeat()}
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallSection}
      >
        NOTE: if you are shipping high value cards and want to take insurance on
        them, please email <a href={`mailto:${contactEmail}`}>{contactEmail}</a>{" "}
        to request pricing on an insured label under our policy from UPS.
      </Typography>
      <Typography
        variant="subtitle1"
        color="textSecondary"
        className={classes.smallSection}
      >
        Please note, Gem Mint Submissions is not a card grader. While our review
        process does offer an evaluation, we DO NOT guarantee any specific
        grades. The grade your card achieves is solely based on what human
        receives your card, on what specific day, and what mood said human is in
        at the time. Our review process is to HELP avoid non-gem mint grades,
        but we CANNOT guarantee any results due to human factors involved at
        submission companies.
      </Typography>
    </>
  );
};
